import React from 'react';
import { createRoot } from 'react-dom/client';
import EmbedMap from './components/EmbedMap';
import './styles/embed.css';

const init = () => {
  const container = document.getElementById('project-map-embed-root');
  if (!container) return;

  const settings = window.drupalSettings?.urbanizeProjectMapEmbed || {};

  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <EmbedMap
        apiUrl={settings.apiUrl || container.dataset.apiUrl}
        mapboxToken={settings.mapboxToken}
        mapboxStyle={settings.mapboxStyle}
      />
    </React.StrictMode>
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
